<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<h1 class="h3 mb-0 text-gray-800">
					Item {{ dados.id }}
				</h1>
				<div>
					<button 
						class="btn btn-success"
						v-if="(this.pedido.estagio_id == 2)
							&& (this.dados.estagio_id == 2)
							&& (parseInt(this.dados.quantidade) > 1)
							&& (parseInt(this.dados.quantidade_finalizada) < parseInt(this.dados.quantidade))"
						@click="finalizeQuantity()">
						<i class="fas mr-2 fa-check"></i>
						Finalizar Quantidade
					</button>
					<item-finalize-unit
						v-if="(this.pedido.estagio_id == 2)
							&& (this.dados.estagio_id == 2)
							&& (this.dados.quantidade > 1)
							&& (this.dados.quantidade_finalizada < this.dados.quantidade)"
						@reload="getDados">	
					</item-finalize-unit>
					<item-btn-next-estagio
						:dados="dados"
						:key="btnNextEstagioKey"
						@reload="getDados">	
					</item-btn-next-estagio>
					<button 
						class="btn btn-primary"
						@click="update">
						<i class="fas fa-edit"></i>
					</button>
					<button 
						class="btn btn-danger"
						@click="confirmDestroy()">
						<i class="fas fa-trash"></i>
					</button>
					<button 
				        @click="$router.go(-1)" 
				        class="btn btn-secondary">
			           	Voltar
			        </button>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<!-- Informações -->
					<item-info :dados="dados"></item-info>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<item-material-card></item-material-card>
				</div>
			</div>
		</div>
		<!-- Finalizar unidades -->
		<item-finalize-quantity @reload="getDados"></item-finalize-quantity>
		<!-- Update Item -->
		<item-update 
			@reload="getDados">
		</item-update>
		<!-- Confirmação para excluir -->
        <bsh-confirm 
        	modal_id="confirm_destroy_item" 
        	:dado_id="$route.params.id" 
        	title="Deseja realmente remover este item?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/itens/destroy/'" 
        	@reload="back()">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dados: [],
				pedido: [],
				btnNextEstagioKey: 1,
				btnFinalizeUnitKey: 1
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/itens/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data.data
	            	this.pedido = response.data.data.pedido
	            	this.btnNextEstagioKey += 1
	            	this.btnFinalizeUnitKey += 1
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			update(){
				$('#update_item').modal('show');
			},
			finalizeQuantity(){
				$('#update_quantidade_finalizada').modal('show');
			},
			confirmDestroy(){
				$('#confirm_destroy_item').modal('show');
			},
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>